import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import WebsiteInputComponent from './WebsiteInputComponent';
export default class SocialButtonsModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "buttons", []);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.buttons = [];
    const buttons = this.attrs.user.socialButtons();
    if (buttons.length) {
      buttons.forEach((button, index) => {
        if (button && button.title) {
          this.createButtonObject(index, button);
        }
      });
    } else {
      this.createButtonObject(0);
    }
  }
  className() {
    return 'SocialButtonsModal Modal--small';
  }
  title() {
    return app.translator.trans('fof-socialprofile.forum.edit.headtitle');
  }
  content() {
    const areAnyIconsBeingFetched = this.buttons.some(button => button.icon() === 'fas fa-circle-notch fa-spin');
    return m("div", {
      className: "Modal-body"
    }, m(Form, null, this.buttons.map(button => WebsiteInputComponent.component({
      button
    })), m("div", {
      className: "Form-group",
      id: "submit-button-group"
    }, m("div", {
      className: "Button Button--primary EditSocialButtons-add",
      style: "margin-left: 1%;",
      onclick: this.addSocialButton.bind(this)
    }, m("i", {
      className: "fas fa-fw fa-plus"
    })), m("div", {
      className: "Button Button--primary EditSocialButtons-del",
      style: "margin-left: 1%;",
      onclick: this.delSocialButton.bind(this)
    }, m("i", {
      className: "fas fa-fw fa-minus"
    })), Button.component({
      type: 'submit',
      style: 'float: right;',
      className: 'Button Button--primary EditSocialButtons-save',
      loading: this.loading,
      disabled: areAnyIconsBeingFetched,
      title: areAnyIconsBeingFetched ? app.translator.trans('fof-socialprofile.forum.edit.save_disabled_fetching_favicons') : null
    }, app.translator.trans('fof-socialprofile.forum.edit.submit')))));
  }
  data() {
    const buttons = [];
    this.buttons.forEach(button => {
      if (button && button.title() && button.url()) {
        buttons.push({
          title: button.title(),
          url: button.url(),
          icon: button.icon()
        });
      }
    });
    return {
      socialButtons: JSON.stringify(buttons)
    };
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    this.attrs.user.save(this.data(), {
      errorHandler: this.onerror.bind(this)
    }).then(this.hide.bind(this)).then(() => {
      $('#app').trigger('refreshSocialButtons', [this.data().socialButtons]);
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  addSocialButton() {
    this.createButtonObject(this.buttons.length);
    m.redraw();
    $('document').ready(() => {
      $("#socialgroup-".concat(this.buttons.length - 1)).slideDown();
    });
  }
  delSocialButton() {
    const curdel = this.buttons.length - 1;
    $("#socialgroup-".concat(curdel)).slideUp('normal', () => {
      this.buttons.splice(curdel, 1);
      m.redraw();
    });
  }
  createButtonObject(key, button) {
    if (button === void 0) {
      button = null;
    }
    if (button == null) {
      this.buttons[key] = {
        index: Stream(key),
        favicon: Stream('none'),
        title: Stream(''),
        url: Stream(''),
        icon: Stream('fas fa-globe')
      };
    } else {
      var _button$icon;
      this.buttons[key] = {
        index: Stream(key),
        favicon: Stream((_button$icon = button.icon) != null && _button$icon.startsWith('favicon') ? 'external' : 'none'),
        title: Stream(button.title),
        url: Stream(button.url),
        icon: Stream(button.icon)
      };
    }
  }
}
flarum.reg.add('fof-socialprofile', 'forum/components/SocialButtonsModal', SocialButtonsModal);